// translations/pages/team/pl.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPagePL = {
  hero: {
    title: 'Zespół',
    intro: 'Adrian Eisenmeier i Nikolai Genov założyli pAIoneer Labs GmbH i kierują nią jako dyrektorzy zarządzający.',
    members: 'Adrian Eisenmeier jest dyplomowanym fizykiem i buduje systemy tam, gdzie spotykają się AI, architektura oprogramowania, ochrona danych i bezpieczeństwo. Nikolai Genov jest doktorem bioinformatyki i liderem technicznym w zakresie wytwarzania oprogramowania wspomaganego przez AI i analityki w regulowanych obszarach ochrony zdrowia, nauk o życiu i finansów. Alina Tselinina jest programistką i inżynierką danych z tytułem magistra matematyki finansowej i aktuarialnej i tworzy aplikacje, interfejsy REST API i potoki danych w Pythonie i R.'
  },
  card: {
    cta: 'Zobacz profil'
  },
  profile: {
    overview: 'Zespół',
    membersLabel: 'Członkowie zespołu'
  }
};
